/**
 * Resolve the mobile shell's "up" target: the Library of the current
 * workspace. The conversations route REQUIRES :workspaceUUID — a bare named
 * target throws a missing-required-param error from param-less routes like
 * /account — so resolve it from the route first, then the store, then fall
 * back to home (which redirects to the right workspace once known).
 *
 * Hierarchical "up", not history.back(): the router guard rewrites
 * stale-workspace URLs, so after a workspace switch the history is full of
 * entries that bounce straight back — a history-based back button reads as
 * dead. Native apps navigate up; so do we.
 */
export function libraryRoute(route, workspaceStore) {
  const workspaceUUID =
    route?.params?.workspaceUUID || workspaceStore?.activeWorkspaceUUID;
  if (workspaceUUID) {
    return { name: "conversations", params: { workspaceUUID } };
  }
  return { path: "/" };
}
